export class File extends Object {
    name: string;
    base64: string;
}


// WEBPACK FOOTER //
// /app/src/model/Entities/File.ts